module.exports = __webpack_public_path__ + "static/img/title(2).8342c69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/title(2).png
// module id = sgtt
// module chunks = 1